import LazyComponent from 'components/LazyComponent';
import {lazy} from 'react';

const accountManagementRoutes = [
	{
		component: LazyComponent(lazy(() => import('./List'))),
		path: '/account-management/list',
	},
	{
		component: LazyComponent(lazy(() => import('./Create'))),
		path: '/account-management/create',
	},
	{
		component: LazyComponent(lazy(() => import('./Update'))),
		path: '/account-management/update/:id',
	},
];

export default accountManagementRoutes;
